"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ViewModel_1 = require("./ViewModel");
/** Retrieves the current value of a form field from the form model returned from the JSON API */
function getFieldValueFromModel(field) {
  if (ViewModel_1.instanceOfListViewModel(field.model)) {
    // field state from API view-model items (list fields with possible multi-select)
    // we map this into an array of selected values
    return field.model.items.filter(function (item) {
      return item.selected;
    }).map(function (item) {
      return item.value;
    });
  }
  if (ViewModel_1.instanceOfInputViewModel(field.model)) {
    // field state from API view-model value (single valued fields)
    // false literal is a falsy value we want to keep (used in checkboxes)
    if (field.model.value === false) {
      return field.model.value;
    }
    // otherwise, we never want a null or undefined value so we default falsy to empty strings
    return field.model.value || '';
  }
  // the model cannot be null or undefined as in React a controlled field must be bound to a non-null value
  return '';
}
exports.getFieldValueFromModel = getFieldValueFromModel;